import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import { useAuthStore } from './stores/auth'
import './assets/css/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

// Restore the session before Vue Router renders the first protected view.
// App.vue's onMounted hook runs after Home.vue has mounted, so restoring it
// there can leave Home with an empty user during its first render.
useAuthStore(pinia).initializeAuth()

app.use(router)

app.mount('#app')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.error('Attendance service worker registration failed', error)
    })
  })
}
